// Nadrama <https://nadrama.com>
// Copyright Nadrama Pty Ltd
// All rights reserved.

export const formatDate = (value: string | Date) =>
  new Intl.DateTimeFormat(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(value));
